// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunMetricItem } from './run-metric-item';
import {
    RunMetricItemFromJSON,
    RunMetricItemFromJSONTyped,
    RunMetricItemToJSON,
    RunMetricItemToJSONTyped,
} from './run-metric-item';

/**
 * 
 * @export
 * @interface GetRunMetricsResponseContent
 */
export interface GetRunMetricsResponseContent {
    /**
     * 
     * @type {number}
     * @memberof GetRunMetricsResponseContent
     */
    failedRuns: number;
    /**
     * 
     * @type {number}
     * @memberof GetRunMetricsResponseContent
     */
    passRate: number;
    /**
     * 
     * @type {number}
     * @memberof GetRunMetricsResponseContent
     */
    passedRuns: number;
    /**
     * 
     * @type {number}
     * @memberof GetRunMetricsResponseContent
     */
    pendingReviewCount?: number;
    /**
     * 
     * @type {Array<RunMetricItem>}
     * @memberof GetRunMetricsResponseContent
     */
    recentRuns?: Array<RunMetricItem>;
    /**
     * 
     * @type {number}
     * @memberof GetRunMetricsResponseContent
     */
    totalFailedRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetRunMetricsResponseContent
     */
    totalRuns: number;
}

/**
 * Check if a given object implements the GetRunMetricsResponseContent interface.
 */
export function instanceOfGetRunMetricsResponseContent(value: object): value is GetRunMetricsResponseContent {
    if (!('failedRuns' in value) || value['failedRuns'] === undefined) return false;
    if (!('passRate' in value) || value['passRate'] === undefined) return false;
    if (!('passedRuns' in value) || value['passedRuns'] === undefined) return false;
    if (!('totalRuns' in value) || value['totalRuns'] === undefined) return false;
    return true;
}

export function GetRunMetricsResponseContentFromJSON(json: any): GetRunMetricsResponseContent {
    return GetRunMetricsResponseContentFromJSONTyped(json, false);
}

export function GetRunMetricsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRunMetricsResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'failedRuns': json['failedRuns'],
        'passRate': json['passRate'],
        'passedRuns': json['passedRuns'],
        'pendingReviewCount': json['pendingReviewCount'] == null ? undefined : json['pendingReviewCount'],
        'recentRuns': json['recentRuns'] == null ? undefined : ((json['recentRuns'] as Array<any>).map(RunMetricItemFromJSON)),
        'totalFailedRecords': json['totalFailedRecords'] == null ? undefined : json['totalFailedRecords'],
        'totalRuns': json['totalRuns'],
    };
}

export function GetRunMetricsResponseContentToJSON(json: any): GetRunMetricsResponseContent {
    return GetRunMetricsResponseContentToJSONTyped(json, false);
}

export function GetRunMetricsResponseContentToJSONTyped(value?: GetRunMetricsResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'failedRuns': value['failedRuns'],
        'passRate': value['passRate'],
        'passedRuns': value['passedRuns'],
        'pendingReviewCount': value['pendingReviewCount'],
        'recentRuns': value['recentRuns'] == null ? undefined : ((value['recentRuns'] as Array<any>).map(RunMetricItemToJSON)),
        'totalFailedRecords': value['totalFailedRecords'],
        'totalRuns': value['totalRuns'],
    };
}
